import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { getOptionsFromRefList } from "@/util/common_function";

const ArrestInformation = ({
  formData,
  updateFormData,
  disabled,
  startingPoint = "",
}) => {
  return (
    <section>
      <IntakeSectionHeader>
        <span>Arrest Information</span>
      </IntakeSectionHeader>

      <FieldSecurityProvider
        entity="DetentionsArrestReports"
        startingPoint={startingPoint}
        bookingsFieldsEnabled={!disabled}
      >
        <FormContainer>
          <Row gutter={16}>
            {/* Case # — always read-only, overrideDisabled forces it disabled
                regardless of field security (matches legacy ASP behavior) */}
            <Col span={12}>
              <SecureFormItem
                fieldName="controllingAgencyCaseNumber"
                overrideDisabled
                formItemProps={{
                  name: [
                    "detentionsArrestReports",
                    0,
                    "controllingAgencyCaseNumber",
                  ],
                  label: "Case #",
                  layout: "vertical",
                }}
              >
                <TextField />
              </SecureFormItem>
            </Col>

            {/* Controlling Agency ORI */}
            <Col span={12}>
              <SecureFormItem
                fieldName="controllingAgencyOriId"
                formItemProps={{
                  name: [
                    "detentionsArrestReports",
                    0,
                    "controllingAgencyOriId",
                  ],
                  label: "Controlling Agency ORI",
                  layout: "vertical",
                }}
              >
                <Select
                  options={getOptionsFromRefList(
                    "Controlling_Agency",
                    false,
                    true,
                    true,
                  )}
                  placeholder="Controlling Agency ORI"
                  showSearch
                  variant="outlined"
                />
              </SecureFormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            {/* Inmate Status */}
            <Col span={12}>
              <SecureFormItem
                fieldName="inmateStatusId"
                formItemProps={{
                  name: ["detentionsArrestReports", 0, "inmateStatusId"],
                  label: "Inmate Status",
                  layout: "vertical",
                }}
              >
                <Select
                  options={getOptionsFromRefList(
                    "Inmate_Status",
                    false,
                    false,
                    true,
                  )}
                  placeholder="Inmate Status"
                  showSearch
                  variant="outlined"
                />
              </SecureFormItem>
            </Col>
          </Row>
        </FormContainer>
      </FieldSecurityProvider>
    </section>
  );
};

export default ArrestInformation;
